module.exports = __webpack_public_path__ + "static/enginuity-logo-5d13cc8a5f483346e62fb09b6e57ed25.png";